import { graphql } from "@opensea/graphql"

export const CurrencyDescriptionFragment = graphql(`
  fragment CurrencyDescription on Currency {
    symbol
    description
  }
`)
